import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
	({ className, ...props }, ref) => (
		<input
			ref={ref}
			className={cn(
				'w-full bg-white border border-line rounded-md px-2.5 py-1.5 text-[17px] text-ink transition-colors',
				'hover:border-line-strong focus:outline-none focus:border-accent placeholder:text-ink-3',
				className
			)}
			{...props}
		/>
	)
);
Input.displayName = 'Input';

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
	({ className, ...props }, ref) => (
		<textarea
			ref={ref}
			className={cn(
				'w-full bg-white border border-line rounded-md px-2.5 py-1.5 text-[17px] text-ink transition-colors resize-y min-h-[70px]',
				'hover:border-line-strong focus:outline-none focus:border-accent placeholder:text-ink-3',
				className
			)}
			{...props}
		/>
	)
);
Textarea.displayName = 'Textarea';
